import { useEffect, useState, useCallback } from "react";
import {
  DataValidationNotification,
  UseDataValidationNotificationsReturn,
} from "../types/DataValidationNotification.type";
import { getPendingDataValidationNotifications } from "../services/dataValidationNotificationService";

export const useDataValidationNotifications = (
  enabled = true,
): UseDataValidationNotificationsReturn => {
  const [notifications, setNotifications] = useState<
    DataValidationNotification[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);

  const fetchNotifications = useCallback(async (): Promise<void> => {
    if (!enabled) {
      return;
    }

    setError(null);

    try {
      const response = await getPendingDataValidationNotifications();

      if (!response.success) {
        setError(response.message || "Failed to fetch notifications");
        setNotifications([]);
        setTotalCount(0);
        return;
      }

      const data = response.data;
      setNotifications(data);
      setTotalCount(data[0]?.total ?? data.length);
    } catch (err: unknown) {
      const errMsg = err instanceof Error ? err.message : String(err);
      setError(errMsg);
      setNotifications([]);
      setTotalCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const timer = window.setTimeout(() => {
      void fetchNotifications();
    }, 0);

    return (): void => {
      window.clearTimeout(timer);
    };
  }, [enabled, fetchNotifications]);

  const refreshNotifications = useCallback((): void => {
    void fetchNotifications();
  }, [fetchNotifications]);

  return {
    notifications,
    totalCount,
    error,
    refreshNotifications,
  };
};
